//codex-- Load a per-employee view default without saving changes made in the scheduler.
import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getFullSchedulerDefault, normalizeSchedulerDepartment } from '../utils/fullSchedulerSettings';

//codex-- Observe the client's employee context so stale account requests cannot change the view.
export default function useSchedulerDepartment(apiUrl, employeeId) {
  const [selectedDept, setDepartment] = useState('Field');
  const manuallySelected = useRef(false);
  const owner = useRef({ apiUrl, employeeId });
  const navigate = useNavigate();

  //codex-- A manual selection wins over a late read; changing accounts starts a fresh read.
  useEffect(() => {
    let active = true;
    if (owner.current.apiUrl !== apiUrl || owner.current.employeeId !== employeeId) {
      //codex-- Preserve selections made while the first employee context was still loading.
      if (owner.current.employeeId || owner.current.apiUrl !== apiUrl) {
        manuallySelected.current = false;
        setDepartment('Field');
      }
      owner.current = { apiUrl, employeeId };
    }
    if (employeeId) {
      getFullSchedulerDefault(apiUrl)
        .then((department) => {
          if (active && !manuallySelected.current) setDepartment(department);
        })
        .catch((error) => {
          if (!active) return;
          if (error.response?.status === 401) navigate('/login');
          else toast.error('Could not load your default department.', { position: 'top-center' });
        });
    }
    return () => { active = false; };
  }, [apiUrl, employeeId, navigate]);

  //codex-- This setter changes only the current scheduler view.
  const setSelectedDept = useCallback((department) => {
    manuallySelected.current = true;
    setDepartment(normalizeSchedulerDepartment(department));
  }, []);

  return [selectedDept, setSelectedDept];
}
